import React from 'react';

import { XingFrameConsumer } from './XingFrameProvider';

const xingConnect = (
  mapStateToProps = (state, ownProps) => ({ ...state, ...ownProps })
) => WrappedComponent => {
  const Wrapper = props => (
    <XingFrameConsumer>
      {state => (
        <WrappedComponent
          {...{ ...mapStateToProps(state, props) }}
          {...props}
        />
      )}
    </XingFrameConsumer>
  );

  Wrapper.displayName = `xingConnect(${WrappedComponent.displayName ||
    WrappedComponent.name ||
    'Component'})`;

  return Wrapper;
};

export default xingConnect;
